<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import DataTable from "@/components/DataTable.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "SellingPrice Changes Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    DataTable,
  },
  data() {
    return {
      filterTitle: "SellingPrice Changes Report",
      data: {
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        product: "",
        page: 1,
        per_page: 50,
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Store PriceChanges Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "SellingPrice Changes Report",
          active: true,
        },
      ],
      totalRows: 1,
      filteredReport: [],
      pageOptions: [10, 25, 50, 100, 200, 1000],
      IsSellingpriceChangesServerPaginated: true,
      serverPerPage: 50,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product",
          sortable: true,
          label: "PRODUCT",
        },
        {
          key: "old_price",
          sortable: true,
          label: "OLD PRICE",
        },
        {
          key: "new_price",
          sortable: true,
          label: "NEW PRICE",
        },
        {
          key: "recordedby",
          sortable: true,
          label: "RECORDED BY",
        },
        {
          key: "recordedon",
          sortable: true,
          label: "RECORDED ON",
        },
      ],
      json_fields: {
        PRODUCT_NAME: "product",
        OLD_PRICE: "old_price",
        NEW_PRICE: "new_price",
        TYPE: "type",
        RECORDED_BY: "recordedby",
        RECORDED_ON: "recordedon",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("products", [
      "Products",
      "SellingpriceChanges",
      "SellingpriceChangesPagination",
      "SellingpriceChangesPaginated",
      "FilterStatus",
    ]),

    rows() {
      return this.IsSellingpriceChangesServerPaginated
        ? this.SellingpriceChangesPagination?.total
        : this.SellingpriceChangesPaginated
        ? this.SellingpriceChangesPaginated.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsSellingpriceChangesServerPaginated) {
          const value =
            this.SellingpriceChangesPagination?.per_page ||
            this.data.per_page ||
            this.serverPerPage;
          return parseInt(value) || this.serverPerPage;
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsSellingpriceChangesServerPaginated) {
          this.data.per_page = value;
          this.data.page = 1;
          this.FetchPriceChanges(this.data);
        }
      },
    },

    currentPage: {
      get() {
        return this.SellingpriceChangesPaginated &&
          this.SellingpriceChangesPagination
          ? this.SellingpriceChangesPagination.current_page
          : 1;
      },
      set(value) {
        if (this.SellingpriceChangesPaginated) {
          this.data.page = value;
          this.FetchPriceChanges(this.data);
        }
      },
    },
  },

  methods: {
    ...mapActions({
      FetchPriceChanges: "products/fetchPriceChanges",
      FetchProducts: "products/fetchProducts",
    }),

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    assiginData() {
      this.filteredReport = this.SellingpriceChanges;
    },

    filterReport() {
      let payload = { ...this.data };

      payload.page = 1;
      if (!payload.per_page) {
        payload.per_page = this.serverPerPage;
      }

      this.FetchPriceChanges(payload);
    },
  },

  watch: {
    SellingpriceChanges(newValue) {
      if (newValue) {
        this.assiginData();
      }
    },
  },
  created() {
    this.FetchPriceChanges(this.data);
    this.FetchProducts();
    this.assiginData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3
                  class="card-title mb-2 text-center"
                  v-html="filterTitle"
                ></h3>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mt-4">
                <download-excel
                  class="btn btn-info"
                  :data="filteredReport"
                  :fields="json_fields"
                  :worksheet="'STOREPRICE CHANGES REPORT ON' + currentdate"
                  type="csv"
                  :name="'Store PriceChanges' + currentdate + '.xls'"
                >
                  Export Excel <i class="fa fa-download"></i>
                </download-excel>
              </div>
              <div class="col-md-3 form-group mb-2">
                <label>FROM</label>
                <input
                  type="date"
                  v-model="data.datefrom"
                  class="form-control"
                  v-limit-future-date
                />
              </div>
              <div class="col-md-3 form-group">
                <label>TO</label>
                <input
                  v-model="data.dateto"
                  type="date"
                  class="form-control"
                  v-limit-future-date
                />
              </div>
              <div class="col-2">
                <div class="form-group">
                  <label>Product</label>
                  <model-list-select
                    :list="
                    Products
                      ? [{ id: '', name: 'All Products' }, ...Products]
                      : []
                  "
                    v-model="data.product"
                    option-value="id"
                    option-text="name"
                    class="mb-3"
                    placeholder="Select Product"
                    @input="filterReport()"
                  >
                  </model-list-select>
                </div>
              </div>
              <div class="col-md-1 mt-4">
                    <button class="btn btn-primary" type="button" @click="filterReport()">
                      <span class="fa fa-filter"></span> Filter
                      <b-spinner
                        v-show="FilterStatus"
                        variant="light"
                        small
                        role="status"
                      ></b-spinner>
                    </button>
                  </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <DataTable
                :columns="fields"
                :rows="SellingpriceChanges || []"
                :total-rows="rows"
                :pagination="SellingpriceChangesPagination"
                :server-pagination="IsSellingpriceChangesServerPaginated"
                :loading="FilterStatus"
              >
                <template #cell(index)="{ index }">
                  {{ (currentPage - 1) * perPage + index + 1 }}
                </template>
                <template #cell(product)="{ row }">
                  {{ row.product }}
                </template>
                <template #cell(old_price)="{ row }">
                  {{ thousandSeperator(row.old_price) }}
                </template>
                <template #cell(new_price)="{ row }">
                  {{ thousandSeperator(row.new_price) }}
                </template>
                <template #cell(recordedby)="{ row }">
                  {{ row.recordedby }}
                </template>
                <template #cell(recordedon)="{ row }">
                  {{ row.recordedon }}
                </template>
              </DataTable>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
